import { useUser } from 'lib/auth';
import useSWR from 'swr';
import { Tenant } from 'utils/tenants';

import { getOrganization } from '../api/getOrganization';


export const useOrganizationById = ({ organizationId, tenantId }: { organizationId: string; tenantId?: Tenant }) => {
  const { roles } = useUser();

  const { data, error, isLoading } = useSWR(`/organizations/${organizationId}`, () =>
    getOrganization(organizationId, roles, tenantId)
  );

  return { organizationData: data, error, isLoading };
};